import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useAuth } from '../context/AuthContext';

// Renders children only if the user holds `permission`; otherwise an inline notice.
const PermissionGate = ({ permission, children }) => {
  const { hasPermission } = useAuth();
  if (hasPermission(permission)) return children;

  return (
    <Box sx={{ mt: 2 }}>
      <Alert severity="warning" icon={<LockIcon />}>
        <AlertTitle>Permission required</AlertTitle>
        This area requires the <strong>{permission}</strong> canonical permission, which your
        current entitlements don&apos;t include.
      </Alert>
    </Box>
  );
};

export default PermissionGate;
